import { gql } from '@apollo/client';

export const SAVED_CARDS = gql`
  query PaymentMethods($companyId: ID!) {
    paymentMethods(companyId: $companyId) {
      id
      isDefault
      card {
        brand
        last4
        expMonth
        expYear
      }
    }
  }
`;

export const PROJECT_PRICE_BY_PROJECT_ID = gql`
  query ProjectPriceByProjectId($projectId: ID!, $participants: Int!, $couponCode: String) {
    projectPriceByProjectId(projectId: $projectId, participants: $participants, couponCode: $couponCode) {
      participants
      participantPrice
      amount
      finalAmount
      discountAmount
      appliedCoupon
      prepaidAmount
      prepaidAmountApplied
    }
  }
`;
